import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {hasImage} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useWidgetState} from '../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {getEventBadge} from '../../../../selectors/events'
import {EventBadge} from '../../../event-badge'
import {EventImage} from '../../../event-image'
import s from './image.scss'

export interface ImageProps {
  event: wix.events.Event | Event_V3
}

export const Image = ({event}: ImageProps) => {
  const {
    allBreakpoints: {isListImageEnabled, isEventBadgeOnImage},
  } = useVisibilityStyles()

  const eventBadge = useWidgetState(state => getEventBadge(state, event))

  return isListImageEnabled() ? (
    <div data-hook={hasImage(event) ? DH.listImage : DH.listImagePlaceholder} className={s.image}>
      <EventImage backgroundFallback event={event} />
      {isEventBadgeOnImage(eventBadge?.type) && <EventBadge onImage event={event} />}
    </div>
  ) : null
}
